import React from "react";
import styled, { keyframes } from "styled-components";
// Assets
import AddImage1 from "../../assets/optimized/business-intelligence.webp";
import AddImage2 from "../../assets/optimized/data-visualisation.webp";
import AddImage3 from "../../assets/optimized/business-analytics-dashboard.webp";
import AddImage4 from "../../assets/optimized/digital-transformation.webp";

export default function Services() {
  const advancedServices = [
    
    // {
    //   title: "Precision Agriculture Intelligence",
    //   description: "Advanced geospatial analysis and real-time disease detection powered by AI and autonomous UAV technology for optimized agricultural yields.",
    //   features: [
    //     "Geospatial field mapping and analysis",
    //     "Real-time crop and animal disease detection",
    //     "Autonomous UAV-based treatment recommendations",
    //     "Yield optimization and predictive analytics",
    //     "Centralized analytics dashboards for farm management"
    //   ]
    // },
    {
      title: "Compliance & Digital Verification",
      description: "Enterprise-grade KYC and compliance platform with multi-layer verification, document authentication, and advanced fraud detection.",
      features: [
        "Multi-layer KYC (Know Your Customer) verification",
        "Document authentication and biometric checks",
        "Real-time fraud detection and high-risk screening",
        "Regulatory compliance monitoring",
        "Automated compliance reporting across jurisdictions"
      ]
    },
    {
      title: "Business Intelligence & Project Management",
      description: "Advanced analytics and real-time dashboards delivering actionable insights across 8+ industries with multilingual AI support.",
      features: [
        "Industry-specific analytics (8+ sectors: Agri, Construction, Healthcare, Manufacturing, etc.)",
        "Advanced reporting and data visualization",
        "Real-time performance dashboards",
        "Integrated 24/7 AI support (English/Setswana)",
        "Predictive analytics and trend forecasting"
      ]
    },
    {
      title: "Multilingual NLU Chatbot Agents",
      description: "Intelligent conversational AI agents with natural language understanding supporting multiple languages for customer engagement, support automation, and enterprise assistance.",
      features: [
        "Multi-language natural language processing (English, Setswana, and more)",
        "Context-aware conversational intelligence",
        "Seamless integration with enterprise systems",
        "24/7 automated customer support and engagement",
        "Advanced intent recognition and entity extraction",
        "Continuous learning and conversation personalization"
      ]
    },
    {
      title: "Multi-Modal Intelligence Extraction",
      description: "Extract and analyze intelligent insights from any data modality including audio, video, text, images, and documents using advanced AI and machine learning.",
      features: [
        "Audio analysis and speech-to-text transcription",
        "Video content analysis and scene understanding",
        "Text mining and sentiment analysis",
        "Image recognition and visual intelligence extraction",
        "Document processing and information extraction",
        "Unified analytics across all modalities",
        "Real-time data ingestion from multiple sources"
      ]
    },
    {
      title: "ESG & Sustainability Solutions",
      description: "Comprehensive environmental, social, and governance solutions for tracking and reducing your carbon footprint while meeting sustainability commitments.",
      features: [
        "Carbon analytics and emissions tracking",
        "Sustainability Operations Center (SOC) engine",
        "Environmental KPI monitoring and reporting",
        "Sustainability metrics dashboards",
        "Regulatory compliance for sustainability standards"
      ]
    },
  ];

  return (
    <Wrapper id="services">
      <div className="whiteBg" style={{ padding: "100px 0", position: "relative", overflow: "hidden" }}>
        <ServiceBackground />
        <div className="container" style={{ position: "relative", zIndex: 2 }}>
          <HeaderInfo>
            <h1 className="font40 extraBold">Five Core Pillars</h1>
            <p className="font16">
              Enterprise-grade intelligence solutions spanning sustainability, agriculture, compliance, insurance, and business analytics.
            </p>
          </HeaderInfo>
          
          <AdvancedServicesSection>
            <SectionTitle className="font32 extraBold">Our Solutions</SectionTitle>
            <AdvancedServicesGrid>
              {advancedServices.map((service, index) => (
                <AdvancedServiceCard key={index}>
                  <ServiceTitle className="font20 extraBold">{service.title}</ServiceTitle>
                  <ServiceDescription className="font14">{service.description}</ServiceDescription>
                  <FeaturesList>
                    {service.features.map((feature, featureIndex) => (
                      <FeatureItem key={featureIndex} className="font13">
                        <FeatureIcon>✓</FeatureIcon>
                        {feature}
                      </FeatureItem>
                    ))}
                  </FeaturesList>
                </AdvancedServiceCard>
              ))}
            </AdvancedServicesGrid>
          </AdvancedServicesSection>
        </div>
        
        <div className="lightBg">
          <div className="container">
            <Advertising className="flexSpaceCenter">
              <AddLeft>
                <h2 className="font40 extraBold">Ready to Transform Your Business?</h2>
                <p className="font16">
                  Join leading enterprises across agriculture, finance, healthcare, construction, and manufacturing already using Anton Tech's intelligent solutions. Experience enterprise-grade intelligence with measurable impact.
                </p>
                <CTAButton href="#contact">
                  Get Started Today
                </CTAButton>
              </AddLeft>
              <AddRight>
                <AddRightInner>
                  <div className="flexNullCenter">
                    <AddImgWrapp1 className="flexCenter">
                      <img src={AddImage1} alt="Business Intelligence Solutions" loading="lazy" width={600} height={427} />
                    </AddImgWrapp1>
                    <AddImgWrapp2>
                      <img src={AddImage2} alt="Advanced Data Visualization" loading="lazy" width={400} height={266} />
                    </AddImgWrapp2>
                  </div>
                  <div className="flexNullCenter">
                    <AddImgWrapp3>
                      <img src={AddImage3} alt="Enterprise Analytics Dashboard" loading="lazy" width={400} height={300} />
                    </AddImgWrapp3>
                    <AddImgWrapp4>
                      <img src={AddImage4} alt="Digital Transformation" loading="lazy" width={1024} height={683} />
                    </AddImgWrapp4>
                  </div>
                </AddRightInner>
              </AddRight>
            </Advertising>
          </div>
        </div>
      </div>
    </Wrapper>
  );
}

// Animated background component for Services
const ServiceBackground = () => (
  <BackgroundContainer>
    <TechGrid />
    <FloatingElements />
  </BackgroundContainer>
);

// Animation keyframes
const gridMove = keyframes`
  0%, 100% {
    transform: translateX(0) translateY(0);
  }
  25% {
    transform: translateX(10px) translateY(-5px);
  }
  50% {
    transform: translateX(-5px) translateY(10px);
  }
  75% {
    transform: translateX(5px) translateY(5px);
  }
`;

const elementFloat = keyframes`
  0%, 100% {
    transform: translateY(0) rotate(0deg);
    opacity: 0.3;
  }
  50% {
    transform: translateY(-20px) rotate(180deg);
    opacity: 0.6;
  }
`;

// Styled components for animated background
const BackgroundContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  pointer-events: none;
  overflow: hidden;
`;

const TechGrid = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: 
    linear-gradient(rgba(7, 148, 135, 0.03) 1px, transparent 1px),
    linear-gradient(90deg, rgba(7, 148, 135, 0.03) 1px, transparent 1px);
  background-size: 50px 50px;
  animation: ${gridMove} 20s linear infinite;
`;

const FloatingElements = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  
  &::before, &::after {
    content: '';
    position: absolute;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background: linear-gradient(135deg, rgba(7, 148, 135, 0.1) 0%, rgba(7, 148, 135, 0.1) 100%);
    animation: ${elementFloat} 8s ease-in-out infinite;
  }
  
  &::before {
    top: 15%;
    right: 10%;
    animation-delay: 0s;
  }
  
  &::after {
    bottom: 25%;
    left: 15%;
    animation-delay: 4s;
    width: 40px;
    height: 40px;
  }
`;

const serviceBackground = keyframes`
  0%, 100% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
`;

const floatElements = keyframes`
  0%, 100% {
    transform: translateY(0px) translateX(0px);
    opacity: 0.3;
  }
  33% {
    transform: translateY(-15px) translateX(10px);
    opacity: 0.6;
  }
  66% {
    transform: translateY(10px) translateX(-5px);
    opacity: 0.4;
  }
`;

const Wrapper = styled.section`
  width: 100%;
  position: relative;
  overflow: hidden;
  
  .whiteBg {
    background: linear-gradient(-45deg, #ffffff, rgba(7, 148, 135, 0.02), rgba(25, 118, 210, 0.02), #ffffff);
    background-size: 400% 400%;
    animation: ${serviceBackground} 20s ease infinite;
    position: relative;
    
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: 
        radial-gradient(circle at 20% 20%, rgba(7, 148, 135, 0.08) 0%, transparent 40%),
        radial-gradient(circle at 80% 80%, rgba(25, 118, 210, 0.06) 0%, transparent 40%),
        radial-gradient(circle at 40% 90%, rgba(7, 148, 135, 0.04) 0%, transparent 50%);
      animation: ${floatElements} 25s ease-in-out infinite;
      z-index: 1;
    }
    
    > * {
      position: relative;
      z-index: 2;
    }
  }
`;

const HeaderInfo = styled.div`
  text-align: center;
  margin-bottom: 80px;
  
  h1 {
    margin-bottom: 20px;
    background: linear-gradient(135deg, #079487 0%, #079487 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }
  
  p {
    color: #666;
    max-width: 600px;
    margin: 0 auto;
  }
`;

const SectionTitle = styled.h2`
  text-align: center;
  margin-bottom: 40px;
  color: #079487;
`;

const AdvancedServicesSection = styled.div`
  margin-bottom: 60px;
`;

const AdvancedServicesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 15px;
  margin-top: 30px;
  
  @media (max-width: 1200px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 15px;
  }
`;const AdvancedServiceCard = styled.div`
  background: white;
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
  border-left: 3px solid #079487;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  animation: slideInUp 0.8s ease-out;
  animation-fill-mode: both;
  
  /* Staggered animation delays */
  &:nth-child(1) { animation-delay: 1.0s; }
  &:nth-child(2) { animation-delay: 1.2s; }
  &:nth-child(3) { animation-delay: 1.4s; }
  &:nth-child(4) { animation-delay: 1.6s; }
  
  @keyframes slideInUp {
    from {
      opacity: 0;
      transform: translateY(30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  &::before {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: linear-gradient(45deg, transparent 30%, rgba(7, 148, 135, 0.05) 50%, transparent 70%);
    transform: rotate(45deg);
    transition: transform 0.6s ease;
    opacity: 0;
  }
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(7, 148, 135, 0.12);
    
    &::before {
      opacity: 1;
      transform: translateX(100%) rotate(45deg);
    }
  }
`;

const ServiceTitle = styled.h3`
  color: #079487;
  margin-bottom: 8px;
  font-size: 16px;
  font-weight: 600;
`;

const ServiceDescription = styled.p`
  color: #666;
  line-height: 1.4;
  margin-bottom: 12px;
  font-size: 13px;
`;

const FeaturesList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const FeatureItem = styled.li`
  display: flex;
  align-items: center;
  margin-bottom: 6px;
  color: #333;
  font-size: 12px;
`;

const FeatureIcon = styled.span`
  background: #079487;
  color: white;
  width: 18px;
  height: 18px;
  min-width: 18px;
  min-height: 18px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  font-size: 12px;
  font-weight: bold;
  line-height: 1;
  flex-shrink: 0;
`;

const Advertising = styled.div`
  margin: 80px 0;
  padding: 100px 0;
  position: relative;
  @media (max-width: 1160px) {
    padding: 100px 0 40px 0;
  }
  @media (max-width: 860px) {
    flex-direction: column;
    padding: 0 0 30px 0;
    margin: 80px 0 0px 0;
  }
`;

const AddLeft = styled.div`
  width: 50%;
  p {
    max-width: 475px;
    line-height: 1.6;
    margin-bottom: 30px;
  }
  @media (max-width: 860px) {
    width: 80%;
    order: 2;
    text-align: center;
    h2 {
      line-height: 3rem;
      margin: 15px 0;
    }
    p {
      margin: 0 auto;
    }
  }
`;

const CTAButton = styled.a`
  background: linear-gradient(135deg, #079487 0%, #079487 100%);
  color: white;
  padding: 15px 30px;
  border-radius: 8px;
  text-decoration: none;
  font-weight: 600;
  display: inline-block;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(7, 148, 135, 0.3);
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(7, 148, 135, 0.4);
  }
`;

const AddRight = styled.div`
  width: 50%;
  position: absolute;
  top: -70px;
  right: 0;
  @media (max-width: 860px) {
    width: 80%;
    position: relative;
    order: 1;
    top: -40px;
  }
`;
const AddRightInner = styled.div`
  width: 100%;
`;
const AddImgWrapp1 = styled.div`
  width: 48%;
  margin: 0 6% 10px 6%;
  img {
    width: 100%;
    height: auto;
    border-radius: 1rem;
    box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
  }
`;
const AddImgWrapp2 = styled.div`
  width: 30%;
  margin: 0 5% 10px 5%;
  img {
    width: 100%;
    height: auto;
    border-radius: 1rem;
    box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
  }
`;
const AddImgWrapp3 = styled.div`
  width: 20%;
  margin-left: 40%;
  img {
    width: 100%;
    height: auto;
    border-radius: 1rem;
    box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
  }
`;
const AddImgWrapp4 = styled.div`
  width: 30%;
  margin: 0 5%auto;
  img {
    width: 100%;
    height: auto;
    border-radius: 1rem;
    box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
  }
`;

// New styled components for Core Services redesign
